import nsApi from '@netsapiens/netsapiens-js/dist/api';

export default ({
  user,
  domain,
  boardId,
  publicId,
}) => new Promise((resolve) => {
  const data = {
    object: 'dashboard',
    action: 'read',
  };

  if (boardId) {
    data.id = boardId;
    data.user = user;
    data.domain = domain;
  }

  if (publicId) { data.public_id = publicId; }

  nsApi.get(data).then((res) => {
    if (res.length) {
      // eslint-disable-next-line no-param-reassign, prefer-destructuring
      res = res[0]; // we want a single board
      while (typeof (res.layouts) === 'string') {
        try {
          res.layouts = JSON.parse(res.layouts);
        } catch (err) {
          console.error('Layout structure could not be parsed. Applying fallback structure.');
          res.layouts = {
            lg: [{
              w: 6,
              h: 4,
              x: 0,
              y: 0,
              moved: false,
              static: false,
            }],
          };
        }
      }

      res.share_details = res.share_details ? JSON.parse(res.share_details) : []; // share_details is an array of share rules

      res.properties = (res.properties && JSON.parse(res.properties)) || {}; // properties is an object of property properties, of course
    }

    resolve(res);
  }).catch((err) => {
    console.error(err);
    const res = { id: boardId, error: err.response.status };
    resolve(res);
  });
});
